// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"255":"87883499","293":"b5c19548","386":"95dd8987","387":"aac6485d","473":"fa43890b","887":"050a3dbf","928":"57a97ccb"}[chunkId] + ".js";
};